import React, { useState,useEffect } from 'react';
import AllCollection from './AllCollection';
import ExtAllCollection from './ExtAllCollection';
import "./Theme20.css";
import { getServicesArray } from '../../../../utils/utility';
import axios from 'axios';
import { environmentVariables } from '../../../../config/env.config';
import moment from 'moment';

const ExtHomeComponent = ({currencySymbol,prodtdata,sendDatafromParent,prc, currentPage, totalPages, onNextPage, onPrevPage, sendDatafromhomecomponet,colordata}) => {
    const rs = prodtdata;
  const [activeTabb, setActiveTabb] = useState("All");

    const minimarketArray1 = prodtdata?.minimktproductArr || []
    const minimarketArray = prc?.data?.data || []
    
    useEffect(() => {
        sendDatafromhomecomponet(activeTabb);
    }, [activeTabb]);

    const prodcutenquiry = (formData) => {
        // butonsubmit(formData)
      };


    const renderContent = () => {
        let filteredProducts;

        if (activeTabb === "All") {
            filteredProducts = minimarketArray;
        } else {
            filteredProducts = minimarketArray.filter(
                product => product.product_service == activeTabb
            );
        }
        

        return <ExtAllCollection currencySymbol={currencySymbol} products={filteredProducts} rs={rs} butonsubmit={prodcutenquiry} sendDatafromParent={sendDatafromParent} currentPage={currentPage}
        totalPages={totalPages}
        onNextPage={onNextPage}
        colordata={colordata}
        onPrevPage={onPrevPage}/>;
    };

    const getButtonClass = (tabName) => {
        return tabName === activeTabb
            ? `bg-coffee  px-4 py-1 text-base rounded-full ${colordata?.dynamicTextHeadingColor? '': 'text-white'} `
            : `px-4 py-1  border-darkUnactive rounded-full text-base  text-b45  ${colordata?.dynamicTextHeadingColor? '': ''}`;
    };
const getButtonStyle = (tabName) => {
    if (tabName === activeTabb) {
        return {
            color:colordata?.dynamicTextHeadingColor ? colordata.dynamicTextHeadingColor:'',
            backgroundColor:colordata?.dynamicTextHeadingColor ?  `${colordata.dynamicTextHeadingColor}40`:'',
            border:`1px solid  ${colordata.dynamicTextHeadingColor || "#936F5E"}40`
        };
    }
    return {
        color:colordata?.dynamicTextHeadingColor ? colordata.dynamicTextHeadingColor:'',
        border:`1px solid  ${colordata.dynamicTextHeadingColor || "#000000"}40`
    }; 
};
    return (
        prodtdata?.is_mini_mktproduct == 1 ? (
        <div>
            <div className='flex overflow-x-auto'>
                <div>
                    <button
                        className={getButtonClass("All")}
                        onClick={() => setActiveTabb("All")}
                        style={{ margin: '0 10px', ...getButtonStyle("All") }}
                    >
                        All
                    </button>
                </div>
                {  rs?.serviceObj?.is_enabled === 1 && getServicesArray(rs?.serviceObj?.content).map((service, index) => (
                    <div key={index}>
                        <button
                            className={getButtonClass(service.id)}
                            onClick={() => setActiveTabb(service.id)}
                            style={{ margin: '0 10px', width:"max-content" ,...getButtonStyle(service.id)}}
                        >
                            {service.name}
                        </button>
                    </div>
                ))}
            </div>
            <div className="px-0 px-md-2 py-2 pb-0">{renderContent()}</div>     
        </div>
         ) : null
    );
};

export default ExtHomeComponent;
